import * as React from "react";
import "@rainbow-me/rainbowkit/styles.css";

import {
  RainbowKitProvider,
  getDefaultWallets,
  connectorsForWallets,
} from "@rainbow-me/rainbowkit";
import {
  argentWallet,
  trustWallet,
  // ledgerWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { configureChains, createConfig, useAccount, WagmiConfig } from "wagmi";
import {
  mainnet,
  // polygon,
  // optimism,
  // arbitrum,
  // zora,
  goerli,
} from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";

const projectId = "a1c39402ea1383c9bae6e093e75e69bd";

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [
    mainnet,
    // polygon,
    // optimism,
    // arbitrum,
    // zora,
    goerli,
  ],
  [publicProvider()]
);

const { wallets } = getDefaultWallets({
  appName: "privateswap",
  projectId,
  chains,
});

const demoAppInfo = {
  appName: "privateswap",
};

const connectors = connectorsForWallets([
  ...wallets,
  {
    groupName: "Other",
    wallets: [
      argentWallet({ projectId, chains }),
      trustWallet({ projectId, chains }),
      // ledgerWallet({ projectId, chains }),
    ],
  },
]);

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
  webSocketPublicClient,
});

export function Providers({ children }) {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider chains={chains} appInfo={demoAppInfo}>
        {mounted && children}
      </RainbowKitProvider>
    </WagmiConfig>
  );
}
